export default "__VITE_ASSET__D$Vo0Phz__"